import { auth } from '@/auth';
import { v4 as uuid } from 'uuid';

// Kept across card mounts: a delayed commit must not become a foreign upload after navigation.
const operations = new Set<string>();
const maxRememberedUploads = 4096;
auth.subscribe(({ origin, accessToken }) => {
    if (origin === 'login' || !accessToken) operations.clear();
});

export function registerAttachmentUpload(): string {
    const id = uuid().replaceAll('-', '');
    operations.add(id);
    if (operations.size > maxRememberedUploads) operations.delete(operations.values().next().value!);
    return id;
}

export function isOwnAttachmentUpload(id?: string): boolean {
    return !!id && operations.has(id.replaceAll('-', '').toLowerCase());
}

export function serializeAttachmentUpload(properties: object): string {
    return JSON.stringify({ ...properties, _originOperationId: registerAttachmentUpload() });
}
